import type { ChartRow, TrendSignalKey } from '../types';
import { formatSecondLabel } from '../utils/trendZoom';

export type TrendWideRowOptions = {
  feature: TrendSignalKey;
  viewLabel: string;
  segmentLabel: string;
  trendNormalizationEnabled: boolean;
  trendLowPassEnabled: boolean;
  overlaySessionIds: number[];
  resolveOverlayValue: (
    sessionId: number,
    second: number
  ) => number | string | null | undefined;
};

export const buildTrendOverlayColumnKey = (sessionId: number) =>
  `Sessione ${sessionId}`;

export const buildTrendModeDisplayLabel = (
  trendNormalizationEnabled: boolean,
  trendLowPassEnabled: boolean
) =>
  [
    trendNormalizationEnabled ? 'normalizzato' : 'reale',
    trendLowPassEnabled ? 'filtrato' : 'non filtrato',
  ].join(' + ');

export const buildTrendWideDataRow = (
  chartRow: ChartRow,
  {
    feature,
    viewLabel,
    segmentLabel,
    trendNormalizationEnabled,
    trendLowPassEnabled,
    overlaySessionIds,
    resolveOverlayValue,
  }: TrendWideRowOptions
) => {
  const overlayColumns = Object.fromEntries(
    overlaySessionIds.map(sessionId => {
      const value = resolveOverlayValue(sessionId, chartRow.second);
      return [buildTrendOverlayColumnKey(sessionId), value ?? ''];
    })
  );

  return {
    Vista: viewLabel,
    Segnale: feature,
    Timeline: formatSecondLabel(chartRow.second),
    Segmento: segmentLabel,
    Normalizzazione: trendNormalizationEnabled ? 'yes' : 'no',
    'Filtro passabasso': trendLowPassEnabled ? 'yes' : 'no',
    Modalita: buildTrendModeDisplayLabel(
      trendNormalizationEnabled,
      trendLowPassEnabled
    ),
    Media: chartRow.mean,
    'Std superiore': chartRow.stdUpper,
    'Std inferiore': chartRow.stdLower,
    ...overlayColumns,
  };
};

export const buildTrendWideDataRows = (
  chartRows: ChartRow[],
  options: TrendWideRowOptions
) => chartRows.map(chartRow => buildTrendWideDataRow(chartRow, options));
